import React, { useState, ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

import { createContext, useContextSelector, useContext } from 'use-context-selector';
import { ScheduleContext } from './ScheduleContext';

export type PatientProps = {
  documentType: string;
  document: string;
  citizenship: string;
  gender: string;
  pregnant: boolean;
  name: string;
  birthDate: string;
  phone: string;
  email: string;
  idPatient?: string;

  eligibilityCardNumber?: string | null;
  eligibilitySubGroup?: string;
  idLife?: string | number;
};

export type ExternalPatient = {
  idPatientExt?: string;
  document?: string;
  documentType?: string;
} & Omit<PatientProps, 'document' | 'documentType'>;

export interface PatientContextProps {
  // patientList: PatientProps[];
  addPatientList: (patient: PatientProps) => PatientProps;
  clearPatientList: () => void;
  // findPatiendById: (id: string) => PatientProps | undefined;
  isModalSystemUnavailableVisible: boolean;
  setIsModalSystemUnavailableVisible: (state: boolean) => void;
  isModalExistingSchedule: boolean;
  setIsModalExistingSchedule: (state: boolean) => void;
  isModalNoEligibility: boolean;
  setIsModalNoEligibility: (state: boolean) => void;
  isModalProductNotCoveredVisible: boolean;
  setIsModalProductNotCoveredVisible: (state: boolean) => void;
  patientSelected: PatientProps | undefined;
  setPatientSelected: (patient: PatientProps) => void;
}

type PatientProviderProps = {
  children: ReactNode;
};

export const PatientContext = createContext({} as PatientContextProps);

export function PatientProvider({ children }: PatientProviderProps) {
  // const [patientList, setPatientList] = useState<PatientProps[]>([]);
  const [patientSelected, setPatientSelected] = useState<PatientProps>();
  const [isModalSystemUnavailableVisible, setIsModalSystemUnavailableVisible] = useState(false);
  const [isModalExistingSchedule, setIsModalExistingSchedule] = useState(false);
  const [isModalNoEligibility, setIsModalNoEligibility] = useState(false);
  const [isModalProductNotCoveredVisible, setIsModalProductNotCoveredVisible] = useState(false);

  // LINK product to patient
  const { changeSchedule, selectedItem: schedule } = useContextSelector(ScheduleContext, state => state);

  const linkProductToPatient = (idPatient: string) => {
    // scheduleItems.map(schedule => {
    if (schedule) {
      schedule.idPatient = idPatient;
      changeSchedule(schedule);
    }
    // });
  };
  // LINK product to patient

  const addPatientList = (patient: PatientProps) => {
    let idPatient = '';

    // const foundedPatient = patientList.find(
    //   item => patient.document === item.document || patient.idPatient === item.idPatient
    // );

    // if (!foundedPatient?.document) {
    idPatient = 'idPatient';
    patient.idPatient = 'idPatient';
    // setPatientList(list => [...list, patient]);

    // LINK product to patient
    // } else {
    // idPatient = patient.idPatient || uuid();

    // const newPatients = patientList.filter(item => item.document !== patient.document);
    // patient.idPatient = idPatient;

    // newPatients.push(patient);
    // setPatientList(newPatients);
    // }

    setPatientSelected(patient);

    if (patient.idPatient) linkProductToPatient(patient.idPatient);
    else linkProductToPatient(idPatient);
    return patient;
  };

  // const findPatiendById = (id: string) => {
  //   return patientList.find(patient => patient.idPatient === id);
  // };
  const clearPatientList = () => {
    // setPatientList([]);
    setPatientSelected(undefined);
  };

  return (
    <PatientContext.Provider
      value={{
        // patientList,
        addPatientList,
        clearPatientList,
        // findPatiendById,
        isModalExistingSchedule,
        isModalNoEligibility,
        isModalProductNotCoveredVisible,
        isModalSystemUnavailableVisible,
        setIsModalExistingSchedule,
        setIsModalNoEligibility,
        setIsModalProductNotCoveredVisible,
        setIsModalSystemUnavailableVisible,
        patientSelected,
        setPatientSelected
      }}
    >
      {children}
    </PatientContext.Provider>
  );
}

export function usePatientContext() {
  return useContext(PatientContext);
}
